import { render, staticRenderFns } from "./group-oncall-editor.vue?vue&type=template&id=635ce1ef&"
import script from "./group-oncall-editor.vue?vue&type=script&lang=ts&"
export * from "./group-oncall-editor.vue?vue&type=script&lang=ts&"
import style0 from "./group-oncall-editor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports